export default {
  login: {
    title: 'ログイン',
    usernameLabel: 'ユーザー名',
    usernamePlaceholder: '英語で始まる 2 ～ 10 個の英語の数字の組み合わせ',
    loginPasswordLabel: 'ログインパスワード',
    loginPasswordPlaceholder: 'ログインパスワードを入力してください',
    googleCodeLabel: 'Google 確認コード',
    googleCodePlaceholder: '6 桁の Google 確認コードを入力してください',
    hasNoAccount: 'まだアカウントがありません,',
    goRegister: '登録に移動',
    onlineCustom: 'オンラインカスタマーサービス',
    loginArgument: 'ログインを続けることは同意することを意味します',
    userArgument: '《利用規約》',
    registerNotEnabled: '登録機能が開いていません。管理者に問い合わせてください',
    usernameRequired: '正しいユーザー名を入力してください',
    loginPasswordRequired: '正しいログイン パスワードを入力してください',
    googleCodeRequired: '正しい Google 確認コードを入力してください',
    loginButton: 'ログイン'
  },
  register: {
    title: '登録',
    usernameLabel: 'ユーザー名',
    usernamePlaceholder: '登録されているユーザー名を入力してください',
    loginPasswordLabel: 'ログインパスワード',
    loginPasswordPlaceholder: '登録ユーザーのログインパスワードを入力してください',
    loginPasswordPreLabel: 'ログインパスワードの確認',
    loginPasswordPrePlaceholder: 'ログインパスワードをもう一度入力してください',
    fudPasswordLabel: 'ファンドパスワード',
    fudPasswordPlaceholder: 'ファンドのパスワードを入力してください',
    inviteCodeLabel: '招待コード',
    inviteCodePlaceholder: '6 桁の招待コードを入力してください',
    registerNeed: '登録を続けることは同意することを意味します',
    registerArgument: '《登録契約書》',
    usernameRequired: '正しいユーザー名を入力してください',
    loginPasswordRequired: '正しいログイン パスワードを入力してください',
    loginPasswordPreRequired: '正しい確認ログイン パスワードを入力してください',
    FundPasswordRequired: '正しいファンドのパスワードを入力してください',
    InvitationCodeRequired: '正しい招待コードを入力してください',
    diffLoginPasswordError: '2 つのログイン パスワードが一致しません',
    registerSuccess: '登録成功',
    registerButton: '登録',
    emailLabel: 'メール',
    emailPlaceholder: 'メールアドレスを入力してください',
    emailCodeLabel: '確認コード',
    emailCodePlaceholder: 'メール確認コードを入力してください',
    second: '2 番目',
    getEmailCodeButton: 'コードを取得',
    emailRequired: '正しい電子メール アドレスを入力して、もう一度お試しください',
    emailCodeRequired: '正しい電子メール確認コードを入力して、もう一度お試しください'
  },
  home: {
    hotCoin: {
      title: '人気のセール',
      more: 'もっと'
    },
    poster: {
      title: 'クイック デポジット',
      enter: '今すぐ入力>',
      subTitle: 'BTC、USDT、ETH などをサポート'
    },
    quickMenus: {
      futuresTrading: '先物取引',
      helpCenter: 'ヘルプセンター'
    },
    ranking: {
      increase: {
        title: 'ライジングリスト'
      },
      clinch: {
        title: '売上高リスト'
      }
    }
  },
  tabBar: {
    home: 'ホーム',
    price: '引用',
    trade: '貿易',
    fund: '資産',
    user: '私の'
  },
  currency: {
    favorite: 'オプション',
    allCurrency: 'スポット',
    dayVol: '24H の量',
    addFavor: '+ 好意を追加'
  },
  trade: {
    bills: '注文',
    todayOpen: '開く',
    star: 'オプション',
    vol: 'ボリューム',
    low: '最低',
    high: '最高',
    timing: '超高速',
    spot: '先物',
    buyMore: 'さらに購入する',
    buyEmpty: '空売りを買う',
    indicator: 'インジケーター',
    indicatorSettings: 'インジケーター設定',
    balance: '私の残高',
    fee: 'サービス料',
    ruleIdError: '有効期限を選択してください',
    deleteFavoriteSuccess: 'お気に入りの通貨を正常に削除しました',
    addFavoriteSuccess: '選択した通貨の追加に成功しました',
    buyIn: '購入',
    sellOut: '売ります',
    holding: '位置を保持する',
    history: '歴史',
    spotOrderConfirm: {
      title: '購入の確認',
      amountPlaceholder: '購入数量を入力してください'
    },
    spotTradeOrder: {
      holding: {
        coin: '通貨',
        buyInAmountPrice: '購入合計価格/単価',
        buyInCount: '数量',
        actions: '操作',
        sellOut: '売ります',
        profit: '損益'
      }
    },
    orderConfirm: {
      title: '注文確認',
      coinName: '通貨',
      direction: '方向',
      price: '現在の価格',
      balance: '残高',
      fee: 'サービス料',
      buyMoreLabel: 'さらに購入',
      buyEmptyLabel: 'ショート購入',
      buyQuantity: '購入数量',
      buyAmount: '購買金額',
      submit: '注文を確認する'
    },
    kline: {
      open: '開く:',
      close: '閉じる:',
      change: '上下:'
    }
  },
  finance: {
    title: 'ファイナンス'
  },
  allFinance: {
    title: '財務管理',
    all: 'すべて'
  },
  financeOrders: {
    title: '誓約命令',
    holdingLabel: '保有',
    historyLabel: '歴史',
    holding: {
      amount: '誓約額',
      rateStr: '収入金額/利回り',
      vcCount: '約束されたコインの数',
      cycle: '位置サイクル',
      day: '日',
      calcStartDate: '開始値の日付',
      serviceAmount: 'サービス料',
      redeemOrder: '引き換える'
    },
    history: {
      incomeAmount: '収入額',
      rateStr: '収量',
      amount: '誓約額',
      vcCount: '約束されたコインの数',
      calcStartDate: '開始値の日付',
      calcEndDate: '終了日',
      cycle: 'サイクル日数',
      serviceAmount: 'サービス料',
      day: '日'
    }
  },
  financeOrderBills: {
    title: '誓約収入請求書',
    amount: '金額',
    balance: 'バランス'
  },
  financeItem: {
    rateStr: '収量',
    buyType: '購入タイプ',
    cycle: 'サイクル日数',
    exchangeRate: '為替レート（仮想通貨為替残高）',
    day: '日',
    cycleType: 'サイクルタイプ',
    serviceRateStr: 'サービス料金'
  },
  buyFinance: {
    title: '購入',
    rateStr: '収量',
    name: '名前',
    buyType: '購入タイプ',
    cycle: 'サイクル日数',
    cycleType: 'サイクルタイプ',
    exchangeRate: '為替レート（仮想通貨為替残高）',
    serviceRateStr: 'サービス料金',
    remark: 'コメント',
    buyAmountLabel: '購入額 ({coin})',
    descriptionTitle: '製品説明',
    descriptionPart1: '1. 本商品は元本保証のない資産運用商品です。相場の変動により元本が損失する可能性があります。投資は慎重に行ってください。',
    descriptionPart2: '2. 支払い決済ルール:',
    descriptionPart3: '決済価格 < リンク価格の場合、BTC は満期後に決済されます。決済額 = 投資額 * (1+ 日 * 年率収益率 / 365)。',
    descriptionPart4: '決済価格 ≥ 固定価格の場合、USDT は満期後に決済されます。決済額 = 投資額 * 固定価格 * (1+ 日 * 年率収益率 / 365)。',
    descriptionPart5: '3. 実際の年率収益率は市場に応じてリアルタイムに変化します。実際の購入取引を参照してください。',
    descriptionPart6: '4. 投資額は市場に応じてリアルタイムに換算されます。実際の購入取引を参照してください。',
    descriptionPart7: '5. 製品購入後、通貨保有ページで確認でき、有効期限が過ぎるとスポット口座に自動的に返金されます。',
    buyButton: '[{coin}] を購入'
  },
  fund: {
    description: '資産',
    recharge: 'リチャージ',
    withdraw: 'コインを引き出す',
    exchange: '転送',
    empty: '財布は空です、行きましょう'
  },
  userCenter: {
    lastLogin: '最終ログイン',
    myTeam: '私のチーム',
    identity: '実名認証',
    walletAddress: 'ウォレットアドレス',
    zskAccount: 'FPS アカウント',
    bankCard: '銀行口座',
    userBills: 'アカウント変更記録',
    timingTradeOrder: '非常に速いポジション',
    spotTradeOrder: '先物ポジション',
    contactTradeOrder: '約定ポジション',
    userReport: 'ユーザーレポート',
    teamReport: 'チームレポート',
    share: '共有したい',
    customer: 'カスタマーサービスに連絡してください',
    helpCenter: 'ヘルプセンター',
    platform: 'プラットフォームの紹介',
    profit: '今日の損益',
    balance: '私の残高',
    withdraw: 'コインを引き出す',
    recharge: 'リチャージ',
    creditStoreLabel: 'クレジット ポイント'
  },
  settings: {
    title: '設定',
    fundPassword: 'ファンドのパスワード',
    googleValidator: 'Google バリデータ',
    editLoginPassword: 'ログインパスワードを変更',
    switchLocale: '言語を切り替える'
  },
  editFundPassword: {
    title: 'ファンドのパスワードを変更',
    currentPasswordLabel: '現在のパスワード',
    currentPasswordPlaceholder: '現在のファンドのパスワードを入力してください',
    newPasswordLabel: '新しいパスワード',
    newPasswordPlaceholder: '変更したファンドのパスワードを入力してください',
    prePasswordLabel: 'パスワードの確認',
    prePasswordPlaceholder: '変更したファンドのパスワードをクリアして再入力',
    tips: 'ファンドのパスワードは取引のための重要な証明書です。慎重に設定し、覚えておいてください。',
    currentPasswordRequired: '現在のファンドのパスワードを入力してください',
    newPasswordRequired: '変更するファンドのパスワードを入力してください',
    prePasswordRequired: '変更するファンドのパスワードを再度入力してください',
    prePasswordDiff: '2 つのパスワード入力が矛盾しています'
  },
  bindFundPassword: {
    title: 'バインドファンドのパスワード',
    fundPasswordLabel: 'ファンドパスワード',
    fundPasswordPlaceholder: 'ファンドのパスワードを入力してください',
    fundPasswordPreLabel: 'パスワードを確認',
    fundPasswordPrePlaceholder: 'ファンドのパスワードをもう一度入力してください',
    fundPasswordRequired: '正しいファンドのパスワードを入力してください',
    fundPasswordPreRequired: '正しい確認パスワードを入力してください',
    fundPasswordDiff: '2 つのパスワードは矛盾しています',
    bindSuccess: 'ファンドのパスワードは正常にバインドされました',
    tips: 'ファンドのパスワードは取引のための重要な認証情報です。慎重に設定し、覚えておいてください。'
  },
  editLoginPassword: {
    title: 'ログインパスワードの変更',
    currentPasswordLabel: '現在のパスワード',
    currentPasswordPlaceholder: '現在のログインパスワードを入力してください',
    newPasswordLabel: '新しいパスワード',
    newPasswordPlaceholder: '変更したログインパスワードを入力してください',
    prePasswordLabel: 'パスワードの確認',
    prePasswordPlaceholder: '変更したログインパスワードをクリアして再入力',
    tips: 'ログインパスワードはログイン認証などに使用する重要な情報です。慎重に設定し、覚えておいてください。',
    currentPasswordRequired: '現在のログインパスワードを入力してください',
    newPasswordRequired: '変更するログインパスワードを入力してください',
    prePasswordRequired: '変更するログインパスワードを再入力してください',
    prePasswordDiff: '2 つのパスワード入力が矛盾しています'
  },
  bindGoogleValidator: {
    title: 'Google Authenticator のバインド',
    qrCodeLabel: 'QR コード',
    keyLabel: 'キー',
    loginPasswordLabel: 'ログインパスワード',
    loginPasswordPlaceholder: 'ログインパスワードを入力してください',
    googleCodeLabel: 'Google 確認コード',
    googleCodePlaceholder: '6 桁の Google 確認コードを入力してください',
    tipsPart11: 'アプリ ストアで Google Authenticator を検索する',
    tipsPart12: 'Google Authenticator を使用して上記の QR コードをスキャンするか、バインドするキーを手動で入力します',
    tipsPart13: '上記の 6 桁の Google 確認コードを入力し、[確認] をクリックして送信してください',
    loginPasswordRequired: 'ログインパスワードを入力してください',
    googleCodeRequired: '6 桁の Google 確認コードを入力してください'
  },
  walletAddress: {
    title: 'ウォレットアドレス',
    add: '+ ウォレットアドレスを追加',
    remark: 'コメント',
    addButton: 'ウォレットアドレスを追加',
    tips: '住所情報を変更または削除したい場合は、カスタマーサービスまでご連絡ください。'
  },
  addWalletAddress: {
    title: 'ウォレットアドレスを追加',
    vcChainNameIdLabel: 'チェーン タイプ',
    vcAccountLabel: 'ウォレットアドレス',
    vcAccountPlaceholder: 'ウォレットアドレスを入力してください',
    remarkLabel: '備考',
    remarkPlaceholder: '備考の内容を入力してください',
    fundPasswordLabel: 'ファンドパスワード',
    fundPasswordPlaceholder: 'ファンドのパスワードを入力してください',
    tips: '追加されたウォレット アドレスは変更できません。情報が正しいことを確認してください。',
    vcIdRequired: '正しい通貨を選択してください',
    vcChainNameIdRequired: '正しいチェーン タイプを選択してください',
    vcAccountRequired: '正しいウォレットアドレスを入力してください',
    fundPwdRequired: '正しいファンドのパスワードを入力してください',
    addSuccess: 'ウォレットアドレスが正常に追加されました'
  },
  receiveWays: {
    title: 'マイバンクカード',
    add: '+ 銀行カードを追加',
    tips: '銀行カード情報を変更または削除したい場合は、カスタマー サービスにお問い合わせください。',
    addCardButton: '銀行カードを追加'
  },
  zskAccount: {
    title: 'FPS アカウント',
    add: '+ FPS アカウントを追加',
    tips: 'アカウント情報を変更または削除するには、カスタマー サービスにお問い合わせください。',
    addCardButton: 'アカウントを追加'
  },
  addZskAccount: {
    title: 'FPS アカウントを追加',
    withdrawNameLabel: '名前',
    withdrawNamePlaceholder: '名前を入力してください',
    withdrawNameRequired: '名前を空にすることはできません',
    zskLabel: 'ZSK',
    zskPlaceholder: 'FPS IDを入力してください',
    fundPasswordLabel: 'ファンドパスワード',
    fundPasswordPlaceholder: 'ファンドのパスワードを入力してください',
    tips: '追加されたアカウントの情報は慎重に入力してください。情報が間違っていたために出金が届かない問題については、当社は責任を負いません。'
  },
  addBankCard: {
    title: '新しい銀行カードを追加する',
    cardNumLabel: '銀行カード番号',
    withdrawNameLabel: '名前',
    withdrawNamePlaceholder: '名前を入力してください',
    withdrawNameRequired: '名前を空にすることはできません',
    zskLabel: 'ZSK',
    zskPlaceholder: 'FPS IDを入力してください',
    zskRequired: '正しい FPS ID を入力してください',
    cardNumPlaceholder: '銀行カード番号を入力してください',
    branchLabel: '支店アドレス',
    branchPlaceholder: '銀行カード支店の住所を入力してください',
    fundPasswordLabel: 'ファンドパスワード',
    fundPasswordPlaceholder: 'ファンドのパスワードを入力してください',
    tips: '銀行カードは取引現金引き出しのための重要なデータです。慎重に入力してください。カード情報の誤った入力による現金の受け取り失敗などの問題については、当社は責任を負いません。',
    backIdRequired: '口座銀行を選択してください',
    cardNumRequired: '正しい銀行カード番号を入力してください',
    fundPwdRequired: '正しいファンドのパスワードを入力してください',
    idCardPlaceholder: 'ID 番号を入力してください',
    idCardLabel: 'ID カード番号',
    idCardRequired: '正しい ID 番号を入力してください',
    cciPlaceholder: '銀行カード CCI を入力してください',
    branchCodePlaceholder: '支店番号ドを入力してください',
    branchCodeLabel: '支店番号',
    katakanaPlaceholder: 'カタカナで入力してください',
    katakanaLabel: 'カタカナ'
  },
  userBills: {
    title: 'アカウント変更記録',
    vcName: '通貨',
    amount: '金額 ({シンボル})',
    balance: 'バランス({シンボル})'
  },
  timingTradeOrder: {
    title: '非常に速い取引注文',
    waiting: {
      title: '注文中',
      amount: '金額',
      period: '期間',
      receivePrice: '購入価格',
      settlement: '決済中'
    },
    history: {
      title: '歴史的命令',
      buyInClose: '購入価格',
      saleOutClose: 'セール価格'
    }
  },
  spotTradeOrder: {
    title: '先物取引注文',
    waiting: {
      title: '注文中',
      buyInAmount: '合計購入価格',
      buyInPrice: '購入単価',
      buyInCount: '購入数量',
      buyInTime: '時間を買う'
    },
    history: {
      title: '歴史的命令',
      buyInAmount: '合計購入価格',
      buyInPrice: '購入単価',
      buyInCount: '購入数量',
      sellOutAmount: '合計販売価格',
      sellOutPrice: '販売単価',
      sellOutTime: '販売時間'
    }
  },
  userReport: {
    title: 'ユーザーレポート',
    profit: '利益',
    timingTradeAmountFee: '非常に速い取引注文/手数料',
    timingTradePrizePoint: '非常に速い取引ボーナス/リベート',
    rechargeInfo: 'リチャージ/手数料',
    withdrawInfo: '出金・手数料',
    exchangeInfo: '交換・手数料'
  },
  userReportDay: {
    title: 'ユーザー日報',
    profit: '利益',
    timingTradeAmountFee: '非常に速い取引注文/手数料',
    timingTradePrizePoint: '非常に速い取引ボーナス/リベート',
    rechargeInfo: 'リチャージ/手数料',
    withdrawInfo: '出金・手数料',
    exchangeInfo: '交換・手数料'
  },
  teamReport: {
    title: 'チームレポート',
    goToReportDay: '日次レポートを表示',
    timingTradeBetAmountServiceCharge: '非常に速い取引注文/サービス料',
    timingTradeBetPrizePoint: '高速取引ボーナス/リベート',
    timingTradeUserAndCount: 'スピードトレーダーの数/取引数',
    rechargeAmountFee: 'リチャージ金額/サービス料',
    rechargePersonCount: 'リチャージ担当者/トランザクション数',
    withdrawAmountFee: '出金額/サービス料',
    withdrawPersonCount: 'お金/取引を引き出した人の数',
    firstRechargeUserAndCount: '初回リチャージ金額/人数',
    usernamePlaceholder: '下位レベルのユーザー名を入力してください',
    previewAllTradeInfo: 'すべてのスピードトレード情報を表示',
    coin: '通貨',
    timingTradeBetAmount: '非常に速い取引の賭け金',
    profit: '利益',
    action: '操作',
    previewReportDay: '日次レポートを表示'
  },
  teamTimingTradeInfo: {
    title: 'チームスピードトレーディング',
    profit: '利益',
    subTitle: 'チームスピードトランザクション情報',
    timingTradeAmountFee: '非常に速い取引注文/サービス手数料',
    timingTradePrizePoint: '非常に速い取引ボーナス/リベート',
    rechargeInfo: 'リチャージ/サービス料金',
    withdrawInfo: '出金/サービス料',
    exchangeInfo: '交換/サービス手数料'
  },
  teamReportDay: {
    title: 'チーム日報',
    subTitle: 'チーム [{username}] の日報',
    timingTradeBetAmountFee: '非常に速い取引注文/サービス手数料',
    timingTradeBetPrizePoint: '高速取引ボーナス/リベート',
    rechargeAmountFee: 'リチャージ金額/サービス料',
    rechargePersonCount: 'リチャージ担当者/トランザクション数',
    timingTradeUserAndCount: 'スピードトレーダーの数/取引数',
    firstRechargePersonCount: '最初のリチャージ金額/トランザクション数',
    withdrawAmountFee: '出金額/サービス料',
    withdrawPersonCount: 'お金/取引を引き出した人の数',
    exchangeAmountFee: '両替金額/サービス手数料'
  },
  share: {
    title: 'シェアしたい',
    qrCodeLabel: 'QR コード',
    registerUrlLabel: '登録アドレス',
    inviteCodeLabel: '招待コード',
    hasNoInviteCode: '現在のアカウントには招待コードがありません、',
    generateInvitationCode: 'ワンクリックで生成してみます',
    tipsPart1: '上記のQRコードを読み取って登録情報を入力して登録してください',
    tipsPart2: '登録アドレスをコピーし、登録情報を記入して登録します',
    tipsPart3: 'このサイトの登録インターフェイスを手動で開き、招待コードを入力して登録します',
    saveImageError: '画像の保存に失敗しました。画像を長押しして保存してください。'
  },
  myTeam: {
    title: '私のチーム',
    usernamePlaceholder: '下位レベルのユーザー名を入力してください',
    point: 'リベート (速度/契約)',
    totalBalance: '残高',
    lastLoginTime: '最終ログイン時刻',
    noLoginTime: 'なし'
  },
  userDetail: {
    username: 'ユーザー名',
    userType: 'ユーザータイプ',
    title: 'ユーザーの詳細',
    pointPercentTiming: '非常に高速なトランザクション リベート',
    pointPercentContract: '契約トランザクション リベート',
    registerWay: '登録メソッド',
    teamCounts: 'チーム番号',
    teamOnline: 'チームオンライン',
    balance: 'バランス',
    registerTime: '登録時刻',
    onlineStatus: 'ログインステータス'
  },
  addUser: {
    title: 'ユーザーの追加',
    addUserDirect: {
      userTypeLabel: 'ユーザータイプ',
      usernameLabel: 'ユーザー名',
      usernamePlaceholder: 'アカウントのユーザー名を入力してください',
      pointTimingLabel: '非常に高速なトランザクション リベート',
      pointContractLabel: '契約トランザクション リベート',
      tips: '初期パスワードは「{password}」です。アカウント開設後、時間内にパスワードを変更するようユーザーに通知してください',
      userTypeRequired: 'アカウントの種類を選択してください',
      usernameRequired: 'アカウントのユーザー名を入力してください',
      pointTimingRequired: '高速トランザクション リベートを選択してください',
      pointContractRequired: '契約取引リベートを選択してください',
      copyTemplate: `
         ユーザー名: {ユーザー名};
         ログインパスワード: {loginPassword};
         ログイン URL: {loginAddress};
         高速取引リベート: {timingTradePoint};
         契約取引リベート: {contactTradePoint};
         `
    }
  },
  recharge: {
    title: 'リチャージ',
    configIdLabel: '入金チャネル',
    chainNameLabel: 'チェーン名',
    amountLabel: 'リチャージ額',
    userCardNameLabel: '支払者',
    userCardNamePlaceholder: '支払者の名前を入力してください',
    fee: 'サービス料',
    receiveAmountTipsPart1: 'リチャージ',
    receiveAmountTipsPart2: '、支払う必要があります',
    tipsPart1: 'オンライン決済インターフェースが不安定なため、現在はオフライン送金リチャージのみがサポートされています。',
    tipsPart2: '実際の送金額を正直に入力してください。そうしないと、システムの審査が失敗し、リチャージの進行状況に影響を与える可能性があります。',
    emptyPart1: '利用可能なリチャージ チャネルがありません、',
    emptyPart2: 'タップして再試行',
    amountRequired: 'リチャージ額を空にすることはできません',
    maxPrecisionError: 'リチャージ金額の小数点以下の桁数は {amountMaxPrecision} 桁までです',
    payUserNameError: '正しい支払者を入力して、もう一度お試しください',
    userMobileLabel: '携帯電話番号',
    userMobilePlaceholder: 'ユーザーの携帯電話番号を入力してください',
    needPayLabel: '支払う必要があります',
    needPayPlaceholder: 'クリックして 金額を入力'
  },
  payDetail: {
    title: '乗り換えのご案内',
    addressLabel: '入金アドレス',
    rechargeAmount: 'リチャージ金額',
    bankNameLabel: '銀行',
    branchLabel: '支店アドレス',
    cardName: '名前',
    cardNum: 'カード番号',
    uploadImgLabel: '支払い資格情報',
    uploadImgPlaceholder: 'クリックして支払い伝票画像をアップロード',
    uploadImgRequired: '支払い伝票の写真をアップロードしてください',
    vcTransferTipsPart1: '1. 入金アドレスをコピーするか、QR コードをスキャンして入金',
    vcTransferTipsPart2: '2. 入金完了後に支払い伝票の画像をアップロード',
    vcTransferTipsPart3: '入金の効率を向上させるため、鮮明で高解像度の証明書の写真を必ずアップロードしてください。関連情報の写真が鮮明でない場合、システムの審査に失敗し、入金の進行に影響を与える可能性があります。 ',
    bankCardTips: '入金の効率を向上させるため、送金者と送金者の名前が同じであることを確認してください。関連する情報が一致しない場合、システムが審査に失敗し、進行に影響を与える可能性があります」預金の。',
    bankCardTransferSuccess: '転送に成功しました'
  },
  rechargeOrder: {
    title: '入金注文',
    payAmount: 'リチャージ額',
    receiveAmount: '受取金額'
  },
  identity: {
    title: '実名情報',
    subTitle: '実名認証には情報認証、身元認証も含まれる',
    name: '名前',
    idType: 'ドキュメントタイプ',
    idNum: 'ID番号',
    demand: '要求する',
    informationVer: '情報の検証',
    idAuthentication: '認証',
    material: '材料'
  },
  verified: {
    title: '実名認証',
    idCardTypeLabel: '証明書の種類',
    idCardFrontSideImgLabel: 'カード表面 SideImgLabel',
    idCardBackSideImgLabel: '証明写真の裏面',
    idCardHandSideImgLabel: '手持ちの証明写真',
    nameLabel: 'ドキュメント名',
    namePlaceholder: 'ID名を入力してください',
    idCardNumLabel: 'ID カード番号',
    idCardNumPlaceholder: 'ID番号を入力してください',
    fundPwdLabel: 'ファンドのパスワード',
    fundPwdPlaceholder: 'ファンドのパスワードを入力してください',
    tips: '情報認証は一度送信すると変更できません。よく確認して正しく入力してください。',
    idCardTypeRequired: 'カードの種類を選択してください',
    idCardFrontSideImgRequired: 'ID カードの正面写真をアップロードしてください',
    idCardBackSideImgRequired: 'ID カードの裏面の写真をアップロードしてください',
    idCardHandSideImgRequired: '手持ちの証明写真をアップロードしてください',
    nameRequired: 'ドキュメントの名前を入力してください',
    idCardNumRequired: 'ID 番号を入力してください',
    fundPwdRequired: 'ファンドのパスワードを入力してください',
    submitSuccess: '認証リクエストは正常に送信されました'
  },
  help: {
    title: 'ヘルプセンター'
  },
  helpDetail: {
    title: 'ヘルプの詳細'
  },
  myMessage: {
    title: '私のプライベートメッセージ'
  },
  messageDetail: {
    title: 'プライベートメッセージの詳細'
  },
  withdraw: {
    title: 'コインを引き出す',
    tips: '資金の安全性と出金の効率性を確保するため、入力された情報が正しいことを慎重に確認してください。出金プロセス中に発生する手数料は残高から差し引かれます。',
    receiveAmountTipsPart1: '出金',
    receiveAmountTipsPart2: '、到着予定',
    fee: 'サービス料',
    myBalance: '[{vcName}] の残高:',
    configIdLabel: '出金チャネル',
    amountLabel: '出金額',
    fundLabel: 'ファンドのパスワード',
    fundPlaceholder: 'ファンドのパスワードを入力してください',
    googleCodeLabel: 'Google 確認コード',
    googleCodePlaceholder: '6 桁の Google 確認コードを入力してください',
    maxPrecisionError: '出金金額の小数点以下の桁数は {amountMaxPrecision} までです',
    amountRequired: '正しい出金額を入力または選択してください',
    bankCardError: '正しい銀行カードを選択してください',
    fundPwdError: '正しいファンドのパスワードを入力してください',
    walletAddressError: '正しいウォレットアドレスを選択してください',
    success: '出金リクエストは正常に送信されました。処理をお待ちください',
    emptyPart1: '利用可能な出金チャネルがありません、',
    emptyPart2: 'タップして再試行してください'
  },
  withdrawOrder: {
    title: '撤回命令',
    requestAmount: '船荷証券の金額',
    receiveAmount: '受取金額'
  },
  locales: {
    title: '言語を切り替える'
  },
  lines: {
    title: 'ライン選択',
    switchLine: 'スイッチライン'
  },
  currencyPop: {
    deleteFavoriteSuccess: 'お気に入りの通貨を正常に削除しました',
    addFavoriteSuccess: 'お気に入りの通貨を正常に追加しました'
  },
  currencySelect: {
    currencyName: '通貨',
    currencyPlaceholder: 'クリックして通貨を選択'
  },
  walletItem: {
    available: '利用可能',
    convert: '変換 (USDT)'
  },
  banks: {
    bankIdLabel: '銀行',
    bankIdPlaceholder: 'クリックして銀行を選択します'
  },
  banksPop: {
    title: '銀行を選択',
    search: '銀行のキーワードを入力してください'
  },
  historyOrderDetail: {
    title: '注文の詳細',
    coin: '取引通貨',
    amount: '注文金額',
    buyInClose: '購入価格',
    sellOutClose: '売り価格',
    isQuest: 'この注文について質問はありますか?',
    connectCustomer: 'カスタマー サービスに連絡しますか?'
  },
  pointSelect: {
    prizeGroupPlaceholder: 'クリックしてユーザー リベートを選択'
  },
  walletAddressSelect: {
    title: 'ウォレットアドレスを選択',
    label: 'ウォレットアドレス',
    placeholder: 'クリックしてウォレットアドレスを選択'
  },
  myCardSelect: {
    title: 'アカウントを選択',
    label: '受取口座',
    placeholder: 'クリックしてアカウントを選択'
  },
  amountInput: {
    amountRange: '最小値 {minAmount}、最大値 {maxAmount}',
    amountMin: '最小値 {minAmount}、上限なし',
    amountErrorEmpty: '{label} が間違っています。確認してもう一度お試しください',
    amountErrorOutRange: '{label} は範囲外です。確認して再試行してください。'
  },
  amountFormItem: {
    placeholderOnlyMin: '最小値 {minAmount}、上限なし',
    placeholderHasMax: '最小値 {minAmount}、最大値 {maxAmount}',
    amountErrorEmpty: '金額が間違っています。確認後にもう一度お試しください',
    amountErrorOutRange: '金額が範囲外です。確認して再試行してください。'
  },
  common: {
    remark: 'コメント',
    saveImage: 'ローカルに保存',
    online: 'オンライン',
    offline: 'オフライン',
    profit: '損益',
    date: '日付',
    period: '期間',
    pointAmount: 'ユーザー リベート金額',
    point: 'ユーザー リベート',
    direction: '方向',
    winLoss: '収入',
    lose: '負ける',
    add: '新規追加',
    win: '勝つ',
    edit: '変更',
    notBind: 'バインドされていない',
    alreadyBind: 'すでにバインドされています',
    enabled: '有効',
    notEnabled: '有効ではありません',
    queryRange: 'クエリ範囲',
    copy: 'コピー',
    orderNum: '注文番号',
    null: 'なし',
    noData: 'まだデータがありません',
    refreshSuccess: 'リフレッシュに成功しました',
    loadMoreData: 'さらにデータをロードする',
    noMoreData: 'これ以上データはありません',
    lookMore: 'もっと見る',
    more: 'もっと見る'
  },
  date: {
    today: '今日',
    yesterday: '昨日',
    last7Days: 'ほぼ 7 日間',
    last14Days: 'ほぼ 14 日間',
    split: 'へ'
  },
  button: {
    save: '保存',
    logout: 'ログアウト',
    confirm: 'OK',
    cancel: 'キャンセル',
    submit: '送信',
    addNow: '今すぐ追加',
    reset: 'リセット',
    nextStep: '次へ',
    goCertification: '認定に移動'
  },
  confirm: {
    title: {
      logout: 'ログアウト',
      unBindFundPassword: 'バインドされていないファンドのパスワード',
      addUserDirect: 'ユーザーを追加',
      addUserInfo: 'ユーザーの追加に成功しました',
      jumpToRechargePage: 'ジャンプを確認',
      unAuthentication: '非実名認証',
      noBindBankCard: '銀行カードは追加されていません',
      noBindCoinAddress: 'ウォレットアドレスは追加されていません',
      tradeConfirm: '取引を確認します',
      sellOutSpotOrder: '売りポジション',
      buyFinance: '購入を確認します',
      redeemOrder: '誓約注文の償還'
    },
    content: {
      logout: '現在のアカウントからログアウトしてもよろしいですか?',
      unBindFundPassword: 'バインドされていないファンドのパスワードが検出されました。アカ​​ウントのセキュリティを確保するために、最初にファンドのパスワードをバインドしてください',
      addUserDirect: '新しいユーザーがまもなく追加されます。情報が正しいことを確認し、[OK] をクリックして続行してください。ユーザー名 [ {username} ]、ユーザー タイプ [ {userType} ]、ログイン パスワード [ {password} ]、および私のスピード取引リベートの差 [ {diffPointTiming} ] と私の契約取引リベートの差 [ {diffPointContract} ]',
      addUserInfo: 'ユーザー名 [ {username} ]; <br /> ログイン パスワード [ {password} ];<br /> ログイン URL [ {loginAddress} ];<br /> エクストリーム トランザクション リベート [ {pointPercentTiming} ];<br / > /> 契約トランザクション リベート [{pointPercentContract}];',
      jumpToRechargePage: 'サードパーティのリチャージ インターフェイスにジャンプしようとしています。続行するには確認をクリックしてください',
      unAuthentication: 'アカウントが実名認証を受けていないことが検出されました。資金の正常な流通を確保するために、最初に実名認証を実行してください',
      noBindBankCard: 'アカウントが銀行カードにバインドされていないか、有効になっていないことが検出されました。資金を正常に流通させるために、最初に銀行カードを追加してください。',
      noBindCoinAddress: 'アカウントにバインドまたは有効化された仮想通貨アカウントがないことが検出されました。資金の正常な循環を確保するために、最初に仮想通貨アカウントのアドレスを追加してください',
      tradeConfirm: '注文が送信されようとしています。注文情報が正しいことを確認してから、[注文を確認] をクリックして送信してください。',
      sellOutSpotOrder: 'ポジション注文が売られようとしています。操作が正しいことを確認し、[OK]をクリックして続行してください。',
      buyFinance: '[{coin}] を購入しようとしています。シェア: {amount} を購入します。操作が正しいことを確認し、[OK] をクリックして続行してください。',
      redeemOrder: '誓約注文 ({orderNum}) が償還されようとしています。操作が正しいことを確認し、「確認」をクリックして続行してください。'
    }
  },
  message: {
    bindSuccess: 'バインド成功',
    successOperation: '操作は成功しました',
    logoutSuccess: '正常に終了',
    editSuccess: '正常に変更されました',
    addSuccess: '正常に追加されました',
    copySuccess: 'コピー成功',
    copyFailed: 'コピーに失敗しました'
  },
  vux: {
    'inline-calendar': {
      week_day_0: '日',
      week_day_1: '1',
      week_day_2: '2',
      week_day_3: '3',
      week_day_4: '4',
      week_day_5: '5',
      week_day_6: '6'
    },
    loading: {
      loading: '読み込み中'
    }
  },
  helpItems: {
    title: {
      part1: '資産換算額はなぜ変わるの？',
      part2: '店頭取引におけるファンドパスワードを忘れた場合の対処方法',
      part3: '店頭取引購入完了後の資金はどこへ流れるのか?',
      part4: 'ニックネームの変更回数を制限したいのはなぜですか',
      part5: '異動の意味、なぜ異動する必要があるのか​​',
      part6: 'ユーザー契約のアカウント資本はどのように計算するのですか?',
      part7: 'オープンポジションに設定されたストップロスとテイクプロフィットの値はいくらですか?」 どのように設定すればよいでしょうか? ',
      part8: '契約リスクを軽減するにはどうすればよいですか?',
      part9: '約定オープンポジションの数量は何を示していますか?',
      part10: '強制清算に関する指示',
      part11: '約定取引ルールとは何ですか？',
      part12: '約定取引における証拠金とは何ですか？',
      part13: '指値注文と成行注文とは何ですか?',
      part14: '契約取引のリスクとは何を意味するのか',
      part15: 'なぜ通貨換算が必要なのですか?',
      part16: '店頭取引の送金後、相手方はなぜ送金の受け取りが間に合わなかったのですか?',
      part17: '店頭でテザー(USDT)を購入するにはどうすればいいですか?'
    },
    content: {
      part1: '現在人民元で保有されているデジタル通貨を資産に変換したときの価値は、デジタル資産の価格変動により変化します。」 デジタル資産の数は変わりません。',
      part2: 'OTC 取引ファンドのパスワードを忘れた場合は、[マイ設定] をクリックしてファンドのパスワードを設定する」に移動するか、カスタマー サービスに連絡してリセットしてください。',
      part3: 'OTC 買い注文が完了すると、資金は資産の法定通貨口座に入力されます。 OTC購入資産を契約取引または先物取引に使用する必要がある場合は、資金移動モジュールに移動して転送してください。 ',
      part4: 'トランザクションのセキュリティ上の理由から、現在、ニックネームの変更は 1 回のみに制限されています。 ',
      part5: 'お客様のさまざまな口座間で資金の独立性を確保し、合理的なリスク管理を容易にするために、主要な取引モジュールの口座はここに分割されます。」 移転とは、さまざまな取引口座間で資産を相互に変換するプロセスを指します。',
      part6: '<p>契約口座資本、計算方法は次のとおりです:</p> <p>契約口座資本 = ポジション証拠金 + ポジション変動損益 + 当座利用可能額</p>',
      part7: 'テイクプロフィットとストップロスは、あなたが設定した利益制限と損失制限です。設定されたストッププロフィットとストップロスの金額に達すると、システムは自動的にポジションを決済します。」 契約購入時のリスクコントロールにご利用いただけます。設定されたテイクプロフィット額の半分は増加額×数量×レバレッジ倍数、ストップロスを設定します。リスクを合理的にコントロールするために、実際の資産状況に応じて設定することをお勧めします。',
      part8: '資金移動により残りの口座の利用可能資産を契約口座に移したり、ポジションを減らすことでリスクを軽減することができます。',
      part9: 'オープンポジションの数量は、購入予定の通貨の数量を示します。 たとえば、BTC/USDT 取引ペアの最初のページで、買いを選択し、価格を 1000USDT として入力し、数量を 10BTC として入力します。これは、単価 1000USDT で 10 BTC を購入することを期待していることを意味します。 ',
      part10: '<p>リスク度は、資産のリスクを測定する指標です。リスク度が 100% に等しい場合、ポジションは清算されたとみなされます。リスク度 = (ポジション証拠金 / 契約口座資本)*100ユーザーがポジションを超過することを防ぐために、システムはリスク度の調整率を設定し、リスク度がシステムが設定したリスク値に達すると、システムは強制的に清算します。 例: システムによって設定された調整率が 10% の場合、リスク度が 90% 以上になると、すべてのポジションがシステムによって強制的に決済されます。 </p> <p>注: 過剰なリスクによってシステムが強制決済を行った場合、すべてのポジションがクローズされるため、不必要な損失を避けるためにリスクを合理的に制御できることを願っています。</p>',
      part11: '<p>取引タイプ</p> <p>取引タイプは、オープン ロング ポジション (買い) とオープン ショート ポジション (売り) の 2 つの方向に分かれています。</p> <p>買いロング (コール) とは、現在の指数が上昇する可能性があると信じており、設定した価格または現在の市場価格で特定の契約を一定量購入したいと考えている場合。 </p> <p>空売り (弱気) とは、現在の指数が下落する可能性があると信じ、設定した価格または現在の市場価格で一定数の特定の契約を売却することを希望することを意味します。 </p> <p>注文方法</p> <p>指値注文: 注文の価格と数量を指定する必要があります</p> <p>成行注文: 数量を設定するだけです注文の価格は現在の市場価格です。</p> <p>ポジション</p> <p>送信した開始注文が完了すると、それはポジションと呼ばれます。</p> <p>契約の配信の問題</p> <p>プラットフォーム契約は、納期が定められていない永久契約です。 システム清算条件が満たされない限り、またはポジションを手動で決済しない限り、ポジションを永久に保持できます。 </p> <p>システムはポジションをクローズします</p> <p>1: ストッププロフィットとストップロスの設定値に達すると、システムは自動的にポジションをクローズします</p> <p>2: リスク高すぎると、システムはポジションを強制的にクローズします。</p>',
      part12: '<p>契約取引では、ユーザーは契約価格と数量、および対応するレバレッジ倍数に応じて、契約履行の金銭的保証として資金を支払うことで契約の取引に参加することができます。このような資金が契約証拠金です。 ユーザーはポジションをオープンするときに証拠金を占有し、ポジションを開くための証拠金が占有されるほど、口座のリスクが高くなります。 </p> <p>証拠金 = (始値 * 数量) / レバレッジ比率</p>',
      part13: '指値注文とは、プラットフォームに取引を委託することを期待する価格を指し、成行注文とは、プラットフォームに直接委託して、現在の価格で取引を行うことを指します。」 ポジションをオープンする際のルールでは、成行注文が指値注文よりも優先されます。 指値注文を選択する場合は、不当な始値による損失を避けるために、現在の通貨の市場価格に応じて合理的にポジションをオープンしてください。',
      part14: 'リスク レベルは契約アカウントのリスク指標であり、リスク レベルが 100% に等しい場合は清算とみなされます。 リスクが 50% を超える場合は、清算による損失を避けるために慎重にポジションをオープンする必要があることをお勧めします。 契約資産の利用可能な資金を補充するか、ポジションを減らすことでリスクを軽減できます。 ',
      part15: '取引所の機能は、資産内のさまざまな通貨での資金のスムーズな循環を可能にすることであり、先物口座で取得した QCC は取引のために自由に USDT に変換できます。」 他のアカウントのUSDTも、取引のために自由にQCCに変換できます。',
      part16: 'まず、お振込の際にご入力いただくお支払い方法が、注文詳細ページに表示されているお支払い方法と全く同じであることをご確認ください。 次に、お支払い方法が即時か遅延かを確認してください。 最後に、システムメンテナンスなどの理由により、ご利用の銀行および決済機関にご連絡ください。',
      part17: '<p>方法 1: 店頭売買リストから買いたい注文を選択し、売買します。 </p> <p>方法 2: 公開ボタンをクリックして、迅速な取引のニーズに応じて買い注文または売り注文を公開します。 システムはすぐに買い手と売り手をマッチングします。 </p> <p>注: 注文書が 15 分経過しても支払われない場合、システムにより注文が自動的にキャンセルされます。期限内にお支払いください。 同日に3回以上注文がキャンセルされた場合、その日のうちに再度取引を行うことはできず、翌日に取引権限が回復されます。 </p>'
    }
  }
}



// WEBPACK FOOTER //
// ./src/locales/ja.js